import { Dayjs } from "dayjs";
import { useSearchParams } from "react-router-dom";
import { DaylightDateFormat } from "../constants/DaylightDateFormat";
import {
  getTodayAsISODate,
  getTodayInServiceCenterTimezoneAsISODate,
} from "../utils/dateTimeHelper";
import { useIsFeatureFlagEnabled } from "../featureFlags/useIsFeatureFlagEnabled";

export const SELECTED_DATE_PARAM_KEY = "date";

type UseDateSearchParamOptions = {
  onDateChanged?: () => void;
  useSicDate?: boolean;
  timeZone?: string;
};

export function useDateSearchParamOrFallbackToToday(
  options?: UseDateSearchParamOptions
): [string, (date: Dayjs | string) => void] {
  const useServiceCenterToday = useIsFeatureFlagEnabled(
    "outbound-OPS-4482-use-service-center-date-client"
  );
  const [searchParams, setSearchParams] = useSearchParams();

  const queryDate = searchParams.get(SELECTED_DATE_PARAM_KEY);

  const date =
    queryDate ??
    (useServiceCenterToday && options?.useSicDate && options.timeZone
      ? getTodayInServiceCenterTimezoneAsISODate(options.timeZone)
      : getTodayAsISODate());

  const setDate = (date: Dayjs | string): void => {
    searchParams.set(
      SELECTED_DATE_PARAM_KEY,
      typeof date === "string" ? date : date.format(DaylightDateFormat.ISO_DATE)
    );
    setSearchParams(searchParams, { replace: true });
    options?.onDateChanged?.();
  };

  return [date, setDate];
}
